import React, { useState, useRef } from "react";
import axios from "axios";


const useCRUDController = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
    apiRoute = "",
    propsCancel = true
}) => {
    const [data, setData] = useState([])
    const [extendResponseData, setExtendResponseData] = useState([])
    const abortControllerRef = useRef(null); // 新增一個 ref 存 controller

    const getData = (params, options = { useCancelToken: true }) => {
        if (options.useCancelToken) {
            // 若已有先前的請求，則取消
            if (abortControllerRef.current) {
                if (propsCancel)
                    abortControllerRef.current.abort();
            }

            // 建立新的 Controller
            abortControllerRef.current = new AbortController();
        }
        onBefore({
            axiosMode: "get"
        })
        return axios.get(apiRoute, {
            params: params,
            signal: options.useCancelToken ? abortControllerRef.current.signal : undefined
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                // setData()
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data?.data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            })
            .catch((error) => {
                if (axios.isCancel?.(error) || error.name === 'CanceledError') {
                    // console.log("Request canceled", error.message);
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error"
                    });
                }
            });
    }
    const postData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        return axios.post(apiRoute,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status


                if (status === "success") {
                    onFinish(
                        {
                            values: { ...responseData },
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            values: { ...responseData },
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
            })
            .catch((error) => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error",
                        values: { ...error?.response?.data } 
                    }
                )
            })

    }
    const patchData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        return axios.patch(apiRoute,
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        return axios.delete(apiRoute,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const exportData = (data) => {
        onBefore({
            axiosMode: "export"
        })
        return axios.get(`${apiRoute}_export/excel`,
            {
                responseType: 'blob',
                params: data,
            },
        )
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '匯出清單.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                setExtendResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "export",
                        status: "success"
                    }
                )
            })
    }
    const importData = (data) => {
        onBefore({
            axiosMode: "import"
        })
        const files = data.target.files[0];
        let form_data = new FormData();
        form_data.append('inputFile', files);
        form_data.append('language', data?.choose_column);
        data?.guide && form_data.append('guide', data?.guide);
        form_data.append('default_column', JSON.stringify(data?.columns));
        return axios
            .post(`${apiRoute}_import/read_sample`, form_data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                setExtendResponseData(responseData.data)

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }
    const downloadData = ({ ...e } = {}) => {
        onBefore({
            axiosMode: "download_sample"
        })
        return axios
            .get(`${apiRoute}_import/manual`, {
                params: {
                    ...e
                },
                responseType: 'blob',
            })
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '匯入範例.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                setExtendResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "download_sample",
                        status: "success"
                    }
                )
            })
    }
    const overData = (data) => {
        onBefore({
            axiosMode: "over"
        })
        return axios
            .post(`${apiRoute}_import/over_data`, data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }
    return {
        ResponseData: data,
        ExtendResponseData: extendResponseData,
        getData,
        postData,
        patchData,
        deleteData,
        exportData,
        importData,
        downloadData,
        overData,
    }
}
export { useCRUDController }

